/**
 * Downloads a file with a given filename
 * @param {string} filename
 * @param {string} content
 * @param {string} filetype
 */
export function download(filename: string, content: string, filetype?: string) {
  const pom = document.createElement('a');
  let data = content;
  if (filetype) {
    data = `data:text/${filetype};charset=utf-8,` + encodeURIComponent(content);
  }
  pom.setAttribute('href', data);
  pom.setAttribute('download', filename);
  pom.click();
}
